import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import './plugins'
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store/index.js'
import i18n from './i18n'
import { PowerJudge } from '@/common/common'
sync(store, router)
Vue.config.productionTip = false
function authorityJudge(path) {
  var item = store.state.base.menus.filter(x => {
    return x.to == path
  })
  if (item.length > 0) {
    return PowerJudge(item[0].role)
  }
  return true
}
router.beforeEach((to, from, next) => {
  if (!to.meta.requireAuth) {
    next()
    return
  }

  if (localStorage.getItem('loginuser') == null) {
    next({
      path: '/',
      query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
    })
    return
  }

  store.state.base.loginuser = JSON.parse(localStorage.getItem('loginuser'))

  //判断是否有路由权限
  if (!authorityJudge(to.path)) {
    store.state.base.confirmDialog.show('无权限访问', {
      type: 'alert'
    })
    return
  }

  if (to.meta.title != null) {
    document.title = to.meta.title
  }
  if (to.query.id != undefined) {
    document.title += '-' + to.query.id
  }
  next()
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
